import { staticColors } from '../../const/colors/staticColors';
import { sizes } from '../../const/sizes';
export const defaultIconColor = 'grey';
export const getIconColor = (color) => {
    const colorMap = {
        grey: staticColors.iconGrey,
        greyLight: staticColors.iconGreyLight,
        danger: staticColors.iconDanger,
        white: staticColors.iconWhite,
        warning: staticColors.iconWarning,
        action: staticColors.iconAction,
        success: staticColors.iconSuccess,
    };
    return colorMap[color];
};
export const iconSizeMap = {
    small: sizes.icon.small,
    medium: sizes.icon.medium,
};
export const defaultIconSize = 'medium';
